<template>
  <div class="ultra-page">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <CarMainBanner :is-mobile="isMobile"
      banner-name="ultra"
      :banner-url="imgUrlPrefix + mainBanner"
      font-color-type="dark"
      mobile-font-color="dark"
      :title="mainTitle"
      :sub-title="subTitle"
      @pageLoad="pageLoad"
    />

    <!-- 上下布局组件: 上文字+下图片 -->
    <CarUpTxtDownImg :is-mobile="isMobile" :txt-img-obj="carUpTxtDownImgObject" />

    <section v-if="isMobile">
      <img class="img-cover" :src="`${imgUrlPrefix}m-sec1_2.jpg`" alt="" />
    </section>

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList" />

    <!-- 3列图片布局 -->
    <section v-if="isMobile">
      <img class="img-cover" :src="`${imgUrlPrefix}m-sec3_1.jpg`" alt="" />
    </section>
    <div v-else class="img-column-box">
      <div class="img-column-layout">
        <!-- 第1列：单图 -->
        <div class="column-item column-item-1">
          <img :src="`${imgUrlPrefix}sec3_1.jpg`" alt="" />
        </div>
        <!-- 第2列：上下2图 -->
        <div class="column-item column-item-2">
          <div class="sub-item"><img :src="`${imgUrlPrefix}sec3_2.jpg`" alt="" /></div>
          <div class="sub-item"><img :src="`${imgUrlPrefix}sec3_3.jpg`" alt="" /></div>
        </div>
        <!-- 第3列：单图 -->
        <div class="column-item column-item-3">
          <img :src="`${imgUrlPrefix}sec3_4.jpg`" alt="" />
        </div>
      </div>
    </div>

    <!-- 纯图片 -->
    <section v-if="isMobile">
      <img class="img-cover" :src="`${imgUrlPrefix}m-sec4_1.jpg`" alt="" />
      <img class="img-cover" :src="`${imgUrlPrefix}m-sec4_2.jpg`" alt="" />
    </section>
    <div v-else style="aspect-ratio: 1920 / 1211;">
      <img class="img-cover" :src="`${imgUrlPrefix}sec4_1.jpg`" alt="" />
    </div>

    <!-- 图文混排组件 -->
    <CarTxtInImgList :is-mobile="isMobile" :txt-img-list="carTxtInImgList2" />

    <!-- 3列图片布局2-->
    <section v-if="isMobile">
      <img class="img-cover" :src="`${imgUrlPrefix}m-sec6_1.jpg`" alt="" />
    </section>
    <div v-else class="img-column-box2">
      <div class="img-column-layout">
        <!-- 第1列：单图 -->
        <div class="column-item column-item-1">
          <img :src="`${imgUrlPrefix}sec6_1.jpg`" alt="" />
        </div>
        <!-- 第2列：单图 -->
        <div class="column-item column-item-2">
          <img :src="`${imgUrlPrefix}sec6_2.jpg`" alt="" />
        </div>
        <!-- 第3列：上下2图 -->
        <div class="column-item column-item-3">
          <div class="sub-item"><img :src="`${imgUrlPrefix}sec6_3.jpg`" alt="" /></div>
          <div class="sub-item"><img :src="`${imgUrlPrefix}sec6_4.jpg`" alt="" /></div>
        </div>
      </div>
    </div>

    <!-- 单张图片 -->
    <section v-if="isMobile">
      <img class="img-cover" :src="`${imgUrlPrefix}m-sec7_1.jpg`" alt="" />
    </section>
    <div v-else class="fill-section-1080">
      <img class="img-cover" :src="`${imgUrlPrefix}sec7_1.jpg`" alt="" />
    </div>

    <!-- 车辆系列展示组件-1行3列 -->
    <CarSeriesComponent :car-series-obj="carSeriesObj" />

    <!-- 用户社群共创 1 -->
    <section v-if="isMobile" class="mobile-ultra-community">
      <div class="mobile-ultra-community-group">
        <img class="img-cover" :src="`${imgUrlPrefix}m-sec9_1.jpg`" alt="" />
        <div class="mobile-ultra-community-box">
          <h5 class="fade-up">涂装共创计划</h5>
          <p class="fade-up">从专属赛事拉花到竞技化外观套件<br>每一款共创涂装<br>都带着玩家的热血印记<br>让每一台车<br>都是赛道上独一无二的存在</p>
        </div>
      </div>
    </section>
    <div v-else class="ultra-community">
      <div class="ultra-community-content">
        <h5 class="fade-up">涂装共创计划</h5>
        <p class="fade-up">从专属赛事拉花到竞技化外观套件<br>每一款共创涂装<br>都带着玩家的热血印记<br>让每一台车<br>都是赛道上独一无二的存在</p>
        <img class="ultra-community-img" :src="`${imgUrlPrefix}sec9_1.jpg`" alt="" />
      </div>
    </div>

    <!-- 用户社群共创 2 -->
    <div class="ultra-community2">
      <h5 class="fade-up" v-html="isMobile ? '赛事社群生态<br>以热爱集结' : '赛事社群生态 · 以热爱集结'"></h5>
      <p v-if="isMobile" class="fade-up">以赛事探索精神为纽带<br>连接每一位心怀远方的越野行者<br>从沙漠戈壁的极限穿越，到专业赛道的激烈角逐<br>用引擎声浪书写属于越野社群的热血记忆</p>
      <p v-else class="fade-up">以赛事探索精神为纽带，连接每一位心怀远方的越野行者，从沙漠戈壁的极限穿越，到专业赛道的<br>
激烈角逐，用引擎声浪书写属于越野社群的热血记忆</p>
      <img class="ultra-community2-img" :src="`${imgUrlPrefix}${isMobile ? 'm-sec9_2.jpg' : 'sec9_2.jpg'}`" alt="用户共创社群活动" />
    </div>

    <!-- 用户共创周边 -->
    <div class="img-column-box3">
      <h5 class="fade-up">让赛场文化延伸到日常</h5>
      <p v-if="isMobile" class="fade-up">从赛事涂装主题装备、专业越野防护套件<br>到品牌联名服饰、赛道限定周边<br>让每一件物品都承载着赛场的热血与温度<br>把竞技激情延伸到日常与穿越的每一刻<br>承载越野热爱</p>
      <p v-else class="fade-up">从赛事涂装主题装备、专业越野防护套件，到品牌联名服饰、赛道限定周边，让每一件物品都承载<br>着赛场的热血与温度，把竞技激情延伸到日常与穿越的每一刻</p>
      <div v-if="isMobile" class="img-column-m-img"><img :src="`${imgUrlPrefix}m-sec9_3.jpg`" alt="让赛场文化延伸到日常"></div>
      <div v-else class="img-column-layout">
        <!-- 第1列：上下2图 -->
        <div class="column-item column-item-1">
          <div class="sub-item sub-item-top"><img :src="`${imgUrlPrefix}sec10_1.jpg`" alt="" /></div>
          <div class="sub-item sub-item-bottom"><img :src="`${imgUrlPrefix}sec10_2.jpg`" alt="" /></div>
        </div>
        <!-- 第2列：上下2图 -->
        <div class="column-item column-item-2">
          <div class="sub-item sub-item-top"><img :src="`${imgUrlPrefix}sec10_3.jpg`" alt="" /></div>
          <div class="sub-item sub-item-bottom"><img :src="`${imgUrlPrefix}sec10_4.jpg`" alt="" /></div>
        </div>
        <!-- 第3列：单图 -->
        <div class="column-item column-item-3">
          <img :src="`${imgUrlPrefix}sec10_5.jpg`" alt="" />
        </div>
      </div>
    </div>
    

    <!-- 底部生活方式组件 -->
    <CarLifeComponent :bg-img="carLifeBg" />
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
import Loading from '../components/Loading.vue'
import CarMainBanner from '../components/CarMainBanner.vue'
import CarUpTxtDownImg from '../components/CarUpTxtDownImg.vue'
import CarTxtInImgList from '../components/CarTxtInImgList.vue'
import CarSeriesComponent from '../components/CarSeriesComponents.vue'
import CarLifeComponent from '../components/CarLifeComponent.vue'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  components: {
    Loading,
    CarMainBanner,
    CarUpTxtDownImg,
    CarTxtInImgList,
    CarSeriesComponent,
    CarLifeComponent,
  },
  mounted() {
    this.$nextTick(() => {
      fadeAnimate();
    });
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    destroyFadeAnimate();
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    mainBanner() {
      return this.isMobile ? 'm-UltraMain.jpg' : 'UltraMain.jpg'
    },
    mainTitle() {
      return this.isMobile ? '看见<br>每一份<br>热爱' : '看见每一份热爱'
    },
    subTitle() {
      return this.isMobile ? '时尚经典 极致越野' : '穿越极限，抵达自由'
    },
    carLifeBg() {
      return this.isMobile ? '/assets/images/m-ultra-life-bg.jpg' : '/assets/images/ultra-life-bg.jpg'
    },

    // 上下布局: 上文字+下图片数据
    carUpTxtDownImgObject() {
      return {
        title: this.isMobile ? '让每一份热爱<br>驰骋专业赛场<br>成就全民越野' : '让每一份热爱，驰骋专业赛场，成就全民越野',
        desc: this.isMobile ? '我们以赛车民主化与赛事生态构建为核心<br>以品牌主办方身份，打造“车+赛事”<br>一体化完整体验，降低专业参赛门槛<br>让更多人轻松站上专业赛场，以赛级硬核实力<br>让专业越野真正惠及全民' : '我们以赛车民主化与赛事生态构建为核心，以品牌主办方身份，打造“车+赛事”一体化完整体验降低专业参赛门槛，让更多人轻松站上专业赛场，以赛级硬核实力，让专业越野真正惠及全民',
        imgList: [this.imgUrlPrefix + 'sec1_1.jpg', this.imgUrlPrefix + 'sec1_2.jpg'],
        mobileImg: this.imgUrlPrefix + 'm-sec1_1.jpg',
      }
    },

    // 图文混排数据
    carTxtInImgList() {
      return [
        {
          tag: '',
          title: this.isMobile ? '赛事级越野<br>专属配置<br>专业团队调校' : '赛事级越野专属配置<br>专业团队调校',
          desc: '专属加宽轮眉，霸气气场拉满<br>竞技前后杠，尽显纯粹机械硬派本色<br>加宽加厚底护板装甲，复杂路况无忧<br>增大进气格栅，穿越无压力',
          img: this.imgUrlPrefix + 'sec2_1.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec2_1.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '拉力赛事基因<br>型格与功能兼备',
          desc: this.isMobile ? '原厂专属撞色时尚涂装<br>深度适配极限越野场景<br>搭配赛事级专业越野调校<br>性能功底远超常规硬派量产车' : '原厂专属撞色时尚涂装，深度适配极限越野场景<br>搭配赛事级专业越野调校，性能功底远超常规硬<br>派量产车',
          img: this.imgUrlPrefix + 'sec2_2.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec2_2.jpg',
          txtLayout: 'left-top',
        },
        {
          tag: '',
          title: '越野硬派基因<br>玩家专属',
          desc: this.isMobile ? '后尾箱标配拓展脱困板，长途越野更安心<br>竞技级尾翼，优化尾部空气乱流<br>提升高速行驶稳定性' : '后尾箱标配拓展脱困板：长途越野更安心<br>竞技级尾翼：优化尾部空气乱流，提升高速行驶稳定性',
          img: this.imgUrlPrefix + 'sec2_3.jpg',
          mobileImg: this.imgUrlPrefix + 'm-sec2_3.jpg',
          txtLayout: 'left-top',
        },
      ]
    },

    // 车辆系列数据
    carSeriesObj() {
      return {
        logo: this.imgUrlPrefix + 'series-logo.png',
        desc: '赛事级越野专属配置   专业团队调校',
        title: this.isMobile ? 'PERFORMANCE<br>运动赛事系列' : 'PERFORMANCE运动赛事系列',
        series: 'PERFORMANCE',
        carList: [
          { img: this.imgUrlPrefix + 'sec8_1.png', name: 'Ultra', link: ''},
          { img: this.imgUrlPrefix + 'sec8_2.png', name: '达喀尔', link: 'UltraT1'},
          { img: this.imgUrlPrefix + 'sec8_3.png', name: '巴丹100', link: 'UltraUtv'},
        ]
      }
    },


  },
  data() {
    const imgUrlPrefix = '/assets/images/ultra/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      
      // 图文混排数据 2
      carTxtInImgList2: [
        {
          tag: '',
          title: '硬核机能美学',
          desc: '采用 麂皮与哑光碳纤维打造<br>以深灰为基底，霓虹紫作为专属标识色<br>通过撞色缝线与氛围灯<br>勾勒出硬朗而细腻的专属质感',
          img: imgUrlPrefix + 'sec5_1.jpg',
          mobileImg: imgUrlPrefix + 'm-sec5_1.jpg',
          txtLayout: 'left-top4',
        },
      ],
      
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    pageLoad() {
      this.isLoading = false
    }
  },
  
}
</script>

<style lang="less" scoped>
.ultra-page {
  font-weight: @fw2;
  font-family: 'TsangerYunHei', sans-serif;
  .img-column-box {
    padding: 6.25vw;
    .img-column-layout {
      display: flex;
      justify-content: space-between;
      gap: 1.875vw;
      .column-item {
        position: relative;
        overflow: hidden;    
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
      .column-item-1 {
        width: 33.85vw;
        height: 33.125vw;
        flex-shrink: 0;
      }
      .column-item-2 {
        width: 29.01vw;
        height: 33.125vw;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 1.875vw;
        .sub-item {
          height: 15.625vw;
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .column-item-3 {
        width: 20.83vw;
        height: 33.125vw;
        flex-shrink: 0;
      }
    }
  }
  .img-column-box2 {
    padding: 6.25vw;
    .img-column-layout {
      display: flex;
      justify-content: space-between;
      gap: 1.875vw;
      .column-item {
        position: relative;
        overflow: hidden;    
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
      .column-item-1 {
        width: 33.85vw;
        height: 33.125vw;
        flex-shrink: 0;
      }
      .column-item-3 {
        width: 29.01vw;
        height: 33.125vw;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 1.875vw;
        .sub-item {
          height: 15.625vw;
          width: 100%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .column-item-2 {
        width: 20.83vw;
        height: 33.125vw;
        flex-shrink: 0;
      }
    }
  }
  .ultra-community {
    width: 100%;
    aspect-ratio: 1920 / 1490;
    background-color: #fff;
    padding: 4.17vw 0 5.37vw;
    .ultra-community-content {
      text-align: center;
      font-weight: @fw2;
      h5 {
        color: #222222;
        font-size: clamp(32px, 2.5vw, 48px);
        line-height: 1.2;
        font-weight: @fw1;
      }
      p {
        margin-top: 0.83vw;
        color: #666666;
        font-weight: @fw2;
        font-size: clamp(16px, 1.25vw, 24px);
      }
    }
    .ultra-community-img {
      width: 87.16vw;
      height: auto;
      margin: 2.44vw auto 0;
    }
  }
  .ultra-community2 {
    background-color: #F7F7F7;
    padding-top: 4.17vw;
    h5 {
      font-weight: @fw1;
      color: #222222;
      font-size: clamp(32px, 2.5vw, 48px);
      text-align: center;
    }
    p {
      font-weight: @fw2;
      color: #666666;
      font-size: clamp(16px, 1.25vw, 24px);
      text-align: center;
      margin-top: 0.83vw;
    }
    .ultra-community2-img {
      width: 88.8vw;
      height: auto;
      margin: 2.44vw auto 0;
    }
  }
  .img-column-box3 {
    padding: 4.16vw 6.25vw 5.72vw;
    h5 {
      font-weight: @fw1;
      color: #222222;
      font-size: clamp(32px, 2.5vw, 48px);
      text-align: center;
    }
    p {
      font-weight: @fw2;
      color: #666666;
      font-size: clamp(16px, 1.25vw, 24px);
      text-align: center;
      margin-top: 0.83vw;
      margin-bottom: 4.16vw;
    }
    .img-column-layout {
      display: flex;
      justify-content: space-between;
      gap: 1.875vw;

      .column-item {
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      // 第1列：宽 513px, 总高 1029px
      .column-item-1 {
        width: 26.72vw;
        height: 53.59vw;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 1.875vw;

        .sub-item-top {
          height: 14.48vw; // 278px
        }
        .sub-item-bottom {
          height: 37.24vw; // 715px
        }
      }

      // 第2列：宽 576px, 总高 1029px
      .column-item-2 {
        width: 30.00vw;
        height: 53.59vw;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 1.875vw;

        .sub-item-top {
          height: 29.95vw; // 575px
        }
        .sub-item-bottom {
          height: 21.77vw; // 418px
        }
      }

      // 第3列：宽 519px, 总高 1029px
      .column-item-3 {
        width: 27.03vw;
        height: 53.59vw;
        flex-shrink: 0;
      }
    }
  }
}
@media (max-width: @mobile-width) {
  .ultra-page {
    .mobile-ultra-community {
      .mobile-ultra-community-group {
        position: relative;
        .mobile-ultra-community-box {
          color: #212020;
          font-weight: @fw2;
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 21.33vw;
          h5 {
            font-size: 8.53vw;
            text-align: center;
            line-height: 1.4;
            font-weight: @fw1;
            line-height: 1.2;
          }
          p {
            font-size: 4.26vw;
            text-align: center;
            line-height: 1.6;
            font-weight: @fw2;
            margin-top: 1.6vw;
          }
        }
      }
    }

    .ultra-community2 {
      background-color: #D9D9D9;
      padding: 4.26vw;
      h5 {
        font-weight: @fw1;
        font-size: 8.53vw;
      }
      p {
        font-weight: @fw2;
        font-size: 4.26vw;
        margin-top: 0.83vw;
        margin-bottom: 13.33vw;
      }
      .ultra-community2-img {
        width: 100%;
        height: auto;
      }
    }

    .img-column-box3 {
      background-color: #D9D9D9;
      padding: 4.26vw;
      h5 {
        font-weight: @fw1;
        font-size: 8.53vw;
      }
      p {
        font-weight: @fw2;
        font-size: 4.26vw;
        margin-bottom: 16vw;
      }
      .img-column-m-img {
        width: 100%;
        img{
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>